<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-card>    
      
      <v-card-title class="display-1">
        {{ cuestionario.Titulo }}   
      </v-card-title>

     <v-divider></v-divider>

      <v-window v-model="numeroPagina">
        <v-window-item :value = "0">
          <v-card-text>
            <span v-html="descripcion"></span>
          </v-card-text>
        </v-window-item>
        
        <template v-for="pagina in cuestionario.Paginas">
          <v-window-item 
            :key="pagina.ID"
            :value = "pagina.Numero">

            <v-card-text class="title">
              {{ pagina.Titulo }}
            </v-card-text>
            
            <v-card-text>
              <v-form>
                <template v-for="pregunta in pagina.Preguntas">

                  <v-card-text 
                    class="title px-0 pb-3"
                    :key="pregunta.ID"
                    v-if="pregunta.TipoRespuesta=='HDR'">
                    {{ pregunta.Pregunta }}
                  </v-card-text>

                  <v-card-text 
                    class="body-1 pa-0"
                    :key="pregunta.ID"
                    v-if="pregunta.TipoRespuesta=='TXT'">
                    <p>{{ pregunta.Pregunta }}</p>
                    <v-text-field
                      class="body-1 py-0 font-weight-medium"
                      single-line
                      :id="pregunta.Pregunta"
                      @input="setRespuesta(pregunta.ID, $event);"
                    ></v-text-field>
                  </v-card-text>

                  <v-card-text 
                    class="body-1 pa-0"
                    :key="pregunta.ID"
                    v-if="pregunta.TipoRespuesta=='MEM'">
                    <p>{{ pregunta.Pregunta }}</p>
                    <v-textarea
                      class="body-1 font-weight-medium"
                      rows=5
                      no-resize
                      :id="pregunta.Pregunta"
                      @input="setRespuesta(pregunta.ID, $event);"
                    ></v-textarea>
                  </v-card-text>
                  
                  <v-card-text 
                    class="body-1 pa-0"
                    :key="pregunta.ID"
                    v-if="pregunta.TipoRespuesta=='VAL'">
                    {{ pregunta.Pregunta }}{{ pregunta.Pagina}}
                    <v-select
                      class="body-1 py-0 px-3 font-weight-medium"
                      :key="pregunta.ID"
                      :items="pregunta.ValoresPosibles"
                      item-text="Valor"
                      item-value="Valor"
                      clearable
                      dense
                      @input="setRespuesta(pregunta.ID, $event);"
                    ></v-select>
                  </v-card-text>

                  <v-card-text 
                    class="body-1 pa-0"
                    :key="pregunta.ID"
                    v-if="pregunta.TipoRespuesta=='RAT'">
                    {{ pregunta.Pregunta }}{{ pregunta.Pagina}}
                    <v-rating
                      :key="pregunta.ID"
                      clearable 
                      hover
                      @input="setRespuesta(pregunta.ID, $event + '');"
                    ></v-rating>
                  </v-card-text>

                  <v-card-text 
                    class="body-1 pa-0"
                    :key="pregunta.ID"
                    v-if="pregunta.TipoRespuesta=='S/N'">
                    {{ pregunta.Pregunta }}
                    <v-switch
                      class="body-1 py-0 font-weight-medium"
                      true-value='S'
                      false-value='N'
                      @change="setRespuesta(pregunta.ID, $event);"
                    ></v-switch>
                  </v-card-text>

                </template>
              </v-form>
            </v-card-text>

          </v-window-item>
        </template>
      </v-window>

      <v-progress-linear   :value="numeroPagina * 100 / cuestionario.Paginas.length"></v-progress-linear>

      <v-card-actions>
        
        <v-btn 
          flat
          color="blue darken-1" 
          @click.native="onCancel">
        Cancelar
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          v-if="numeroPagina !== 0"
          color="primary"
          @click="numeroPagina--" >
        Anterior
        </v-btn>

        <v-btn
          v-if="numeroPagina === 0"
          color="primary"
          @click="numeroPagina = 1">
        Empezar
        </v-btn>
        
        <v-btn
          v-if="(numeroPagina > 0) && (numeroPagina !== cuestionario.Paginas.length)"
          color="primary"
          @click="numeroPagina++">
        Siguiente
        </v-btn>
          
        <v-btn 
          :disabled="respuestas.length === 0"
          v-if="numeroPagina === cuestionario.Paginas.length"
          color="success"
          @click.native="onSave">
        Guardar
        </v-btn>

      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<style>
</style>

<script>
  import axios from '@/http-common'
  import { CUESTIONARIOS_REQUEST } from '../store/actions/cuestionarios'

  import { mapState } from 'vuex'

  export default {
    name: 'cuestionario',
    props: {
      'idCuestionario': { type: Number, required: true }
    },
    data: function () {
      return {
        dialog: true,
        numeroPagina: 0,
        respuestas: []
      }
    },
    methods: {
      setRespuesta(ID, valor) {
        let i = this.respuestas.findIndex(respuesta => respuesta.ID == ID);

        if (valor) {
          if (i == -1) 
            this.respuestas.push({
              ID: ID,
              Valor: valor
            })
          else
            this.respuestas[i] = {
              ID: ID,
              Valor: valor
            }
        }
        else {
          if (i != -1)
            this.respuestas.splice(i, 1)
        }
      },
      onCancel() {
        this.dialog = false

        this.$router.go(-1)
      },
      onSave() {
        this.dialog = false
        
        axios.post('/cuestionarios/' + this.idCuestionario + '/respuestas', 
          this.respuestas
        )
        .then(() => {
          this.$store.dispatch(CUESTIONARIOS_REQUEST)
          .then(() => {
            this.$router.push('/')
          })
          .catch(() => {
            
          })
        })
        .catch(() => {
          
        })    
      },
    },
    computed: {
      descripcion: function() {
        return this.cuestionario.Descripcion.replace(/(?:\r\n|\r|\n)/g, '<br />')
      },
      ...mapState({
        cuestionario(state) {
          return state.cuestionarios.cuestionarios.find(cuestionario => cuestionario.ID == this.idCuestionario)
        }
      })
    }
    
  }
</script>